import {
  Button,
  Column,
  Flex,
  Row,
  Stack,
  SvgPencil,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { LocTagInvite } from 'src/types/LineOfCredit';
import {
  currencyFormatter,
  transformPenniesToDollar,
} from 'src/utilities/currency-utils';

export interface GroupsTableItemProps {
  group: LocTagInvite;
  isUpdating: boolean;
  isRemoving: boolean;
  isDisabled: boolean;
  onRemoveGroup: () => void;
  onOpenUpdateGroupForm: () => void;
}

export function GroupsTableItem({
  group,
  isUpdating,
  isRemoving,
  isDisabled,
  onRemoveGroup,
  onOpenUpdateGroupForm,
}: GroupsTableItemProps): JSX.Element {
  return (
    <Row alignItems="center">
      <Column phone={4}>{group.name}</Column>
      <Column phone={4}>
        {currencyFormatter(Number(transformPenniesToDollar(group.budget)))}
      </Column>
      <Column phone={4}>
        <Flex
          width="100%"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
          height="24px"
        >
          <Stack x="md">
            <Button
              variant="tertiary"
              className="tableActionButtons"
              onClick={onOpenUpdateGroupForm}
              disabled={isDisabled || isRemoving || isUpdating}
            >
              <SvgPencil aria-label="Edit" />
            </Button>
          </Stack>
          <Button
            variant="tertiary"
            className="tableActionButtons"
            onClick={onRemoveGroup}
            disabled={isDisabled || isUpdating}
            isLoading={isRemoving}
          >
            <SvgX aria-label="Remove" />
          </Button>
        </Flex>
      </Column>
    </Row>
  );
}
